"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vatRegex = exports.validatePropertiesCount = exports.validatePhoneNumber = exports.validatePassword = exports.validateEmail = exports.validateCountOfProperty = exports.isValidTaxIdentifierCountry = exports.isUsSite = exports.isUkSite = exports.isSpainSite = exports.isSWSwitchIPM = exports.isPortugueseSite = exports.isPPM = exports.isNzSite = exports.isNetNewIPM = exports.isEMEABrandSite = exports.isDSABrandSite = exports.isBillingErrorMaxAttemptReached = exports.isAuSite = exports.isAddressInBillingInfoAvailable = exports.isAddressFromQuebec = exports.excludeTaxIdentifier = exports.checkingVatInfoBtnStatus = exports.checkSoftwareDetailsBtnStatus = exports.checkReviewVatEditBtnStatus = exports.checkReviewModalBtnStatus = exports.checkPayoutDetailsBtnStatus = exports.checkMailingAddressBtnStatus = exports.checkCreateWebformContinueBtnStatus = exports.checkCreateAccountBtnStatus = exports.checkCompanyLocBtnStatus = exports.checkBusinessModelBtnStatus = exports.checkBrandDeterminationBtnStatus = exports.checkBillingInfoBtnStatus = exports.checkBasicInfoBtnStatus = void 0;
var _validator = _interopRequireDefault(require("validator"));
var _lodash = require("lodash");
var _stabAddressFormConfigurator = _interopRequireDefault(require("@homeaway/stab-address-form-configurator"));
var _localStorageDataHandler = require("./localStorageDataHandler");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const validateEmail = email => {
  return _validator.default.isEmail(email);
};
exports.validateEmail = validateEmail;
const validatePassword = password => {
  return /^(?=.*[0-9])(?=.*[a-zA-Z])(.+){7,}$/.test(password);
};
exports.validatePassword = validatePassword;
const validatePhoneNumber = (phoneNumber, countryCode) => {
  if (!phoneNumber) {
    return false;
  }
  const strippedPhoneNumber = phoneNumber.replace(/[^0-9]/g, '');
  const numberToCheck = countryCode + strippedPhoneNumber;
  if (_constants.PHONE_DENY_LIST.includes(numberToCheck)) {
    return false;
  }
  const phoneRegex = /^[\d\-\s\(\)\+]+$/;
  return phoneRegex.test(phoneNumber);
};
exports.validatePhoneNumber = validatePhoneNumber;
const validatePropertiesCount = count => {
  return /^[1-9]\d*$/.test(count);
};
exports.validatePropertiesCount = validatePropertiesCount;
const validateCountOfProperty = count => {
  return /^[0-9]*$/.test(count);
};
exports.validateCountOfProperty = validateCountOfProperty;
const isUsSite = siteName => siteName === 'homeaway_us' || siteName === 'vrbo' || siteName === 'vr';
exports.isUsSite = isUsSite;
const isSpainSite = siteName => siteName === 'homeaway_es';
exports.isSpainSite = isSpainSite;
const isUkSite = siteName => siteName === 'homeaway_uk';
exports.isUkSite = isUkSite;
const isPortugueseSite = siteName => siteName === 'homeaway_pt';
exports.isPortugueseSite = isPortugueseSite;
const isNetNewIPM = userType => userType === 'IPM';
exports.isNetNewIPM = isNetNewIPM;
const isPPM = userType => userType === 'PPM';
exports.isPPM = isPPM;
const isSWSwitchIPM = userType => userType === 'IPM_SOFTWARE_SWITCH';
exports.isSWSwitchIPM = isSWSwitchIPM;
const isEMEABrandSite = siteName => siteName === 'homeaway_uk' || siteName === 'abritel' || siteName === 'homeaway_de' || siteName === 'homeaway_it' || siteName === 'homeaway_pt' || siteName === 'homeaway_es';
exports.isEMEABrandSite = isEMEABrandSite;
const dsaBrandSite = ['abritel', 'homeaway_de', 'homeaway_it', 'homeaway_pt', 'homeaway_es'];
const isDSABrandSite = siteName => dsaBrandSite.includes(siteName);
exports.isDSABrandSite = isDSABrandSite;
const isAuSite = siteName => siteName === 'homeaway_au';
exports.isAuSite = isAuSite;
const isNzSite = siteName => siteName === 'homeaway_nz';
exports.isNzSite = isNzSite;
const isStateInAddress = country => {
  const addressForm = _stabAddressFormConfigurator.default.getConfigByCountry(country);
  return addressForm.hasOwnProperty('stateProvince');
};
const checkCreateAccountBtnStatus = state => {
  return !(0, _lodash.isEmpty)(state) && state.firstName && state.lastName && state.phoneNumber && state.companyName && state.email && state.password && !(state.firstNameError || state.lastNameError || state.phoneNumberError || state.companyNameError || state.emailError || state.passwordError);
};
exports.checkCreateAccountBtnStatus = checkCreateAccountBtnStatus;
const checkCreateWebformContinueBtnStatus = state => {
  return !(0, _lodash.isEmpty)(state) && state.emailAddress && state.firstName && state.lastName && state.phoneNumber && state.numberOfProperty && state.companyName && !(state.emailError || state.firstNameError || state.lastNameError || state.phoneNumberError || state.companyNameError || state.propertyCountError);
};
exports.checkCreateWebformContinueBtnStatus = checkCreateWebformContinueBtnStatus;
const isBillingErrorMaxAttemptReached = () => parseInt((0, _localStorageDataHandler.getBillingSubmitErrorAttempt)(), 10) === _constants.BILLING_ERROR_MAX_ATTEMPT;
exports.isBillingErrorMaxAttemptReached = isBillingErrorMaxAttemptReached;
const checkBillingInfoBtnStatus = state => {
  let isValid = false;
  if (!(0, _lodash.isEmpty)(state) && state.cardName && state.expireMonth && state.expireYear && state.billingCountry && state.billingAddressLine1 && state.billingCity && state.billingPostalCode && state.isPanValid && state.isCvnValid && !(state.cardNameError || state.expireMonthError || state.expireYearError || state.panErrorClassName || state.cvnErrorClassName) && !isBillingErrorMaxAttemptReached()) {
    isValid = isStateInAddress(state.billingCountry) ? !!state.billingState : true;
  }
  return isValid;
};

// VAT validation pattern to match server-side pattern
exports.checkBillingInfoBtnStatus = checkBillingInfoBtnStatus;
const vatRegex = /^[A-Z]{2}[A-Z0-9]+$/;
exports.vatRegex = vatRegex;
const isVatValid = vatNumber => {
  if (!vatNumber) {
    return false;
  }
  if (!vatRegex.test(vatNumber)) {
    return false;
  }
  return true;
};
const checkingVatInfoBtnStatus = state => {
  let isValid = false;
  const validVatNumber = state.useRvsCountries ? !!state.vatNumber : isVatValid(state.vatNumber);
  const validVatAddress = state.vatAddressCountry && state.vatAddressLine1 && state.vatCity && state.vatPostalCode;
  if (!(0, _lodash.isEmpty)(state) && state.vatInformationCountry && validVatNumber && validVatAddress) {
    isValid = isStateInAddress(state.vatAddressCountry) ? !!(state.vatState || state.vatStateSelect) : true;
  }
  return isValid;
};
exports.checkingVatInfoBtnStatus = checkingVatInfoBtnStatus;
const checkCompanyLocBtnStatus = state => {
  return !(0, _lodash.isEmpty)(state) && state.companyName && state.companyCountryCode && (!(state.registrationNumberChoice === 'Yes') || state.registrationNumber) && (!state.showBusinessType || state.businessType);
};
exports.checkCompanyLocBtnStatus = checkCompanyLocBtnStatus;
const checkBasicInfoBtnStatus = state => {
  var _state$firstName, _state$lastName;
  return !(0, _lodash.isEmpty)(state) && ((_state$firstName = state.firstName) === null || _state$firstName === void 0 ? void 0 : _state$firstName.trim()) && ((_state$lastName = state.lastName) === null || _state$lastName === void 0 ? void 0 : _state$lastName.trim()) && state.email && !(state.firstNameError || state.lastNameError || state.emailError);
};
exports.checkBasicInfoBtnStatus = checkBasicInfoBtnStatus;
const checkSoftwareDetailsBtnStatus = state => {
  return !(0, _lodash.isEmpty)(state) && state.softwareName && state.softwareId && state.systemId && !(state.softwareNameError || state.softwareIdError);
};
exports.checkSoftwareDetailsBtnStatus = checkSoftwareDetailsBtnStatus;
const checkBusinessModelBtnStatus = state => {
  return !(0, _lodash.isEmpty)(state) && state.businessModelChoice && (state.businessModelChoice === _constants.MERCHANT_OF_RECORD.SUPPLIER || state.businessModelChoice === _constants.MERCHANT_OF_RECORD.EG);
};
exports.checkBusinessModelBtnStatus = checkBusinessModelBtnStatus;
const checkMailingAddressBtnStatus = state => {
  let isValid = false;
  if (!(0, _lodash.isEmpty)(state) && state.mailingCountry && state.mailingAddressLine1 && state.mailingCity && state.mailingPostalCode && state.billingCountry && state.billingAddressLine1 && state.billingCity && state.billingPostalCode) {
    if (isStateInAddress(state.mailingCountry)) {
      isValid = !!state.mailingState;
    } else if (isStateInAddress(state.billingCountry)) {
      isValid = !!state.billingState;
    } else {
      isValid = true;
    }
  }
  return isValid;
};

// eslint-disable-next-line complexity
exports.checkMailingAddressBtnStatus = checkMailingAddressBtnStatus;
const checkReviewModalBtnStatus = state => {
  let isValid = false;
  if (state.enableVatModal) {
    if (state.showRegistrationNumber && state.vatChoice === 'No') {
      isValid = !!(state.vatCountryCode && state.registrationNumber);
    } else if (!(0, _lodash.isEmpty)(state) && state.addressCountry && state.vatCountryCode && isVatValid(state.vatNumber) && state.addressLine1 && state.city && state.postalCode) {
      isValid = isStateInAddress(state.addressCountry) ? !!state.state : true;
    }
  } else if (state.enableAccountModal && !(0, _lodash.isEmpty)(state) && state.firstName && state.lastName && state.dialingCountryCode && state.phoneNumber && state.addressCountry && state.companyName.trim().length > 0 && state.companyCountryCode && state.addressLine1 && state.city && state.postalCode && state.billingCountry && state.billingAddressLine1 && state.billingCity && state.billingPostalCode) {
    if (isStateInAddress(state.addressCountry) && isStateInAddress(state.billingCountry)) {
      isValid = !!state.state && !!state.billingState;
    } else {
      isValid = true;
    }
  }
  return isValid;
};
exports.checkReviewModalBtnStatus = checkReviewModalBtnStatus;
const checkReviewVatEditBtnStatus = state => {
  let isValid = false;
  if (state.enableAccountModal && !(0, _lodash.isEmpty)(state) && state.firstName && state.lastName && state.dialingCountryCode && state.phoneNumber && state.addressCountry && state.companyName && state.companyCountryCode && state.addressLine1 && state.city && state.postalCode && state.billingCountry && state.billingAddressLine1 && state.billingCity && state.billingPostalCode) {
    if (isStateInAddress(state.addressCountry) && isStateInAddress(state.billingCountry)) {
      isValid = !!state.state && !!state.billingState;
    } else {
      isValid = true;
    }
  }
  return isValid;
};
exports.checkReviewVatEditBtnStatus = checkReviewVatEditBtnStatus;
const checkBrandDeterminationBtnStatus = state => {
  return !(0, _lodash.isEmpty)(state) && !!state.currency && Object.keys(state.primarySite).length > 0;
};
exports.checkBrandDeterminationBtnStatus = checkBrandDeterminationBtnStatus;
const checkPayoutDetailsBtnStatus = (state, currency) => {
  return !(0, _lodash.isEmpty)(state) && !!state.bankingCountryCode && !!currency && !(state.showBankingState && !state.bankingState);
};
exports.checkPayoutDetailsBtnStatus = checkPayoutDetailsBtnStatus;
const isAddressInBillingInfoAvailable = billingDetails => {
  return billingDetails && billingDetails.billingAccountInfo && typeof billingDetails.billingAccountInfo.billingAccountAddresses !== 'undefined' && billingDetails.billingAccountInfo.billingAccountAddresses.length > 0;
};
exports.isAddressInBillingInfoAvailable = isAddressInBillingInfoAvailable;
const isAddressFromQuebec = address => !!(address && address.country && address.stateProvince && address.country === _constants.QUEBEC_COUNTRY_CODE && address.stateProvince === _constants.QUEBEC_STATE_CODE);
exports.isAddressFromQuebec = isAddressFromQuebec;
const vatCountries = ['AT', 'EE', 'FI', 'GR', 'IT', 'LV', 'IL', 'SM'];
const excludeTaxIdentifier = value => {
  return vatCountries.includes(value);
};
exports.excludeTaxIdentifier = excludeTaxIdentifier;
const validTaxIdentifierCountries = ['FR', 'DE', 'PT', 'ES', 'GB'];
const isValidTaxIdentifierCountry = value => {
  return validTaxIdentifierCountries.includes(value);
};
exports.isValidTaxIdentifierCountry = isValidTaxIdentifierCountry;
//# sourceMappingURL=validate.js.map